var _defs, _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _path4, _text, _rect, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGidIaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gidIaCoreBg",
    cx: "50%",
    cy: "38%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#002B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#001B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00102E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gidLimeRing",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C6E419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#A6C10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7FA004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gidCyanAccent",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gidIaBadgeGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A6C10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C9E81B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 56,
    fill: "url(#gidIaCoreBg)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 55,
    stroke: "url(#gidLimeRing)",
    strokeWidth: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 18 60 A 42 42 0 0 1 102 60",
    stroke: "url(#gidCyanAccent)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeDasharray: "4 5",
    opacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 24 78 A 42 42 0 0 0 96 78",
    stroke: "#A6C10B",
    strokeWidth: 1.5,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 60,
    r: 2.8,
    fill: "#38BDF8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 60,
    r: 2.8,
    fill: "#A6C10B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 19 C 90 25.2 92.8 28 99 28 C 92.8 28 90 30.8 90 37 C 90 30.8 87.2 28 81 28 C 87.2 28 90 25.2 90 19 Z",
    fill: "#C6E419",
    filter: "url(#softGlow)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 29 24 C 29 27.2 30.8 29 34 29 C 30.8 29 29 30.8 29 34 C 29 30.8 27.2 29 24 29 C 27.2 29 29 27.2 29 24 Z",
    fill: "#38BDF8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 63,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "'Montserrat', 'Inter', 'Segoe UI', Arial, sans-serif",
    fontWeight: 900,
    fontSize: 35,
    letterSpacing: 1
  }, "\n    GID\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 73,
    width: 50,
    height: 22,
    rx: 11,
    fill: "url(#gidIaBadgeGrad)",
    stroke: "#001842",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 88.5,
    textAnchor: "middle",
    fill: "#001842",
    fontFamily: "'Montserrat', 'Inter', 'Segoe UI', Arial, sans-serif",
    fontWeight: 900,
    fontSize: 13.5,
    letterSpacing: 2
  }, "\n    \u2726 IA\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGidIaIcon);
export default __webpack_public_path__ + "static/media/gid-ia-icon.b59d8988d2db62c107f58487c8967825.svg";
export { ForwardRef as ReactComponent };